import Vue from 'vue'

export default {
	state: {
		previous: {},
	},
	mutations: {
		loadPrevious (state, payload) {
			state.previous = payload
		},
		addPrevious (state, payload) { 
			Vue.set(state.previous, payload.key, payload.val)  
		},	
	},
	actions: {
		async fetchPrevious ({commit, getters}, payload = null) {
			commit('clearError')
			commit('setLoading', true)

			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound
			}


			try {
				const previous = await Vue.$db.collection(gameId).doc(round)
				.collection('previous')
				.get()

				if (previous.empty) {//no previous
					console.log('no previous')	
				}
				else {
					const res = {}
					previous.forEach(doc => {
						const prev = doc.data()
						for (let key in prev) {
							res[key] = prev[key]
						}
					})
				
					commit('loadPrevious', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addPrevious ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const previousRef = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('previous')
				.get()

				if (previousRef.empty) {
					const prev = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
						.collection('previous')
						.add({[payload.key]: payload.val})
					//console.log(prev)
				}
				else {
					const id = previousRef.docs[0].id
					const _ = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
					.collection('previous').doc(id)
					.set({[payload.key]: payload.val}, {merge: true})
				}
				commit('setLoading', false)
				commit('addPrevious', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
	},
	getters: {
		previous (state) {
			return state.previous
		},
		afAcceptancePrevious (state) {
			if (state.previous.afAcceptance)
				return state.previous.afAcceptance
			return null
		},
		awarenessPrevious (state) {
			if (state.previous.awareness)
				return state.previous.awareness
			return null
		},
		toUpgrade (state) {
			if (state.previous.toUpgrade)
				return state.previous.toUpgrade
			return null
		}
	}
}